export default {
    forbidden: 'Доступ запрещен',
    notFound:  'Страница не найдена',
};
